import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimEmail',
  standalone: true
})
export class TrimEmailPipe implements PipeTransform {

  transform(email: string): string {
    if (!email) {
      return email;
    }
    return email.replace(/[\/\\\?%]+$/, '');
  }
}
